import { RouteHttpVerb } from "../factory";
export var locationRestPluginGet = {
  path: "/plugin",
  method: RouteHttpVerb.GET
};